import { Config } from '@leverege/plugin';
import { GlobalState } from '@leverege/ui-redux';
function allowEditing(context) {
  const allow = Config.get('LayoutViewerSelector', 'allowEditing');
  if (typeof allow === 'boolean') {
    return allow;
  }
  if (typeof allow === 'function') {
    return allow(context);
  }
  if (typeof allow === 'string') {
    const persona = GlobalState.get()?.ui?.activePersona?.name;
    if (persona) {
      if (persona === allow) {
        return true;
      }
      const arr = allow.split(',').map(s => s.trim());
      return arr.includes(persona);
    }
  }
  return true;
}
export default {
  allowEditing
};